/**
 * BotonReportarProblema — el botón de ícono "Reportar un problema" de las
 * barras superiores, sobre el kit de soporte (`src/soporte`).
 *
 * El kit pone el diálogo, el borrador y el envío; aquí solo el disparador con
 * los estilos de la barra: 'onDark' para la barra oscura interna y 'default'
 * para la barra clara del portal (mismos estilos que ThemeToggle).
 */
import { Bug } from 'lucide-react'
import clsx from 'clsx'
import { ReportarProblemaButton, type SoporteConfig } from '../soporte'

export interface BotonReportarProblemaProps {
  variant?: 'default' | 'onDark'
  /** Canal del reporte; sin él, el de `configurarSoporte` (interno). */
  config?: SoporteConfig
}

export default function BotonReportarProblema({
  variant = 'default',
  config,
}: BotonReportarProblemaProps) {
  return (
    <ReportarProblemaButton
      config={config}
      trigger={(abrir, etiqueta) => (
        <button
          type="button"
          onClick={abrir}
          aria-label={etiqueta}
          title={etiqueta}
          className={clsx(
            'flex h-9 w-9 items-center justify-center rounded-lg',
            'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brand-500 focus-visible:ring-offset-2 dark:focus-visible:ring-offset-surface-900',
            variant === 'onDark'
              ? 'text-surface-300 hover:bg-white/10 hover:text-white'
              : 'border border-surface-200 bg-white text-surface-600 hover:text-surface-900 dark:border-surface-700 dark:bg-surface-900 dark:text-surface-300 dark:hover:text-white',
          )}
        >
          <Bug size={16} aria-hidden="true" />
        </button>
      )}
    />
  )
}
